import { PageRef } from 'providers/page-ref';

export type AdminExerciseListPageParams = {};

export const IAdminExerciseListPage: PageRef<AdminExerciseListPageParams, void> = {
  pageName: 'AdminExerciseListPage',
} as PageRef<AdminExerciseListPageParams, void>;
